<template>
  <CModal @mtdclosemodal="mtdClose" :show="boo_modal" :title="title" :size="'lg'" :centered="true" :btn_cancel="true"
    :btn_ok="true" :booTitile="true">
    <div class="container">
      <textarea rows="10" placeholder="ESCRIBA UN MENSAJE PARA ENVIAR, PUEDE AÑADIR EMOTICONES."
        class="form-control form-control-sm" v-model="message">
      </textarea>
    </div>
    <template #footer>
      <CButton class="btn-secondary" @click="mtdClose" :style="{ color: 'black' }">
        <i class="fa fa-times"></i>&nbsp;Cerrar
      </CButton>
      <CButton @click="mtdSendWsp" class="btn btn-success">
        <i class="far fa-paper-plane"></i> Enviar mensaje
      </CButton>

    </template>
  </CModal>
</template>

<script>
import CModal from "../../shared/modals/cModalFormCom.vue";
import { mapActions } from "vuex";

export default {
  name: "c-sendwsp-modal",
  components: {
    CModal,
  },
  data() {
    return {
      swal: null,
      message: "",
      castMessagge: [],
    };
  },
  props: {
    title: String,
    boo_modal: Boolean,
    client: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtdClose() {
      this.$emit("closeModalSendWsp");
    },
    mtdSendWsp: function () {
      this.castMessagge = [];
      this.castMessagge.push({
        clientId: this.client.id,
        clientName: this.client.name,
        clientPhone: this.client.phone,
        message: this.message
      });
      this.post({
        url:
          this.$store.getters.get__url +
          "/birthay/send/wsp",
        token: this.$store.getters.get__token,
        params: {
          wsp: this.castMessagge
        }
      })
        .then((response) => {
          if (response.statusCode == 200) {
            this.message = "";
            Swal.fire({
              title: "MENSAJES ENVIADOS!!.",
              icon: "success",
            });
            this.mtdClose();
          }
        })
        .catch((errors) => { });
    }
  },
};
</script>

<style scoped></style>